import * as React from 'react'
function SvgDataStock(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M30 4a2 2 0 012 2v6h3a1 1 0 011 1v14a1 1 0 01-1 1h-3v6a2 2 0 11-4 0v-6h-3a1 1 0 01-1-1V13a1 1 0 011-1h3V6a2 2 0 012-2zM10 8a2 2 0 012 2v4h3a1 1 0 011 1v10a1 1 0 01-1 1h-3v4a2 2 0 11-4 0v-4H5a1 1 0 01-1-1V15a1 1 0 011-1h3v-4a2 2 0 012-2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgDataStock
